export default __webpack_public_path__ + "static/media/upload.475ec0e4.svg";